import React, { Component }  from 'react'
import { Icon, Modal, Button, Form, Input } from 'semantic-ui-react'

import constants from '../../constants'

const optionsPaymentTypes = constants.paymentTypes;

class PaymentsAdd extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orNumber: '',
      orDate: undefined,
      amount: '',
      showModal: false,
      paymentId: '',
      studentId: '',
      filename: '',
      type: ''
    };
  }

  handleChange = (e, { name, value }) => {
    this.setState({ [name]: value })
  }

  handleSubmit = () => {
    const data = {
      orNumber: this.state.orNumber,
      orDate: this.state.orDate,
      amount: this.state.amount,
      studentId: this.state.studentId,
      type: this.state.type,
      filename: this.props.paymentFile ? this.props.paymentFile.name : null,
    };
    this.props.handleSubmit(data);
    this.setState({
      orNumber: '',
      orDate: undefined,
      amount: '',
      studentId: '',
      filename: '',
      type: ''
    })
    this.closeModal();
  }

  closeModal = () => this.setState({ showModal: false })

  openModal = () => this.setState({ showModal: true })

  render() {
    let optionsStudents;
    if (this.props.students) {
      optionsStudents = this.props.students.map((student,index) => {
        const studentName = student.lastName + ', '+ student.firstName;
        return (
            { key: student.studentId, value: student.studentId, text: studentName }
        )
      })
    }

    return (
      <Modal
        trigger={
          <Button icon floated='right' labelPosition='right' color='green' onClick={this.openModal}> <Icon name='add' />
          Add Payment
          </Button>
        }
        open={this.state.showModal}
        onClose={this.closeModal}
        closeIcon
        >
        <Modal.Header>Add Payment</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.orNumber} name='orNumber' label='OR Number' placeholder='OR Number' onChange={this.handleChange}/>
                <Form.Field>
                  <label>OR Date</label>
                  <Input value={this.state.orDate} name='orDate' type='date' placeholder='OR Date' onChange={this.handleChange}/>
                </Form.Field>
            </Form.Group>

            <Form.Group widths='equal'>
              <Form.Field control={Input} value={this.state.amount} name='amount' label='Amount' placeholder='Amount' onChange={this.handleChange}/>
              <Form.Select
                fluid
                search
                clearable
                name='studentId'
                label='Student'
                placeholder='Student'
                options={optionsStudents}
                onChange={this.handleChange}
                value={this.state.studentId}
              />
              <Form.Select
                fluid
                search
                clearable
                name='type'
                label='Type'
                placeholder='Type'
                options={optionsPaymentTypes}
                onChange={this.handleChange}
                value={this.state.type}
              />

            </Form.Group>
            <Form.Group widths='equal'>
              <Form.Field
                control={Input}
                type="file"
                label='OR Image'
                placeholder='OR Image'
                onChange={(e) => this.props.handleUploadFileChange(e.target.files[0])}
              />
            </Form.Group>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => this.handleSubmit()}>Submit</Button>
        </Modal.Actions>
      </Modal>
    )
  }
};

export default PaymentsAdd;
